import progressBar, { defaultState as progressBarState } from '@avalara/bat-apps-shared/client/reducers/progress-bar';
import { combineReducers } from 'redux';

import type { Reducer } from 'redux';

import abTestingStore from '../store/ab-testing';
import avataxSignupStore from '../store/avatax-signup';
import billingContactStore from '../store/billing-contact';
import buyFlowStore from '../store/buy-flow';
import dataStore from '../store/data';
import economicNexusStore from '../store/economic-nexus';
import esbStore from '../store/esb';
import featuresStore from '../store/features';
import nextBestProductStore from '../store/next-best-product';
import offerStore from '../store/offer';
import orderStore from '../store/order';
import partnerStore from '../store/partner';
import questionnaireStore from '../store/prequal-questionnaire';
import productDetailStore from '../store/product-detail';
import returnsStore from '../store/returns';
import riskAssessmentStore from '../store/risk-assessment';
import sharedSignupStore from '../store/shared-signup';
import systemStore from '../store/system';
import account, { defaultState as accountState } from './account';

import type { Action } from '@avalara/types/actions';
import type { State } from '@avalara/types/reducer-states';

const reducer: Reducer<State, Action> = combineReducers({
  abTesting: abTestingStore.reducer,
  account,
  avataxSignup: avataxSignupStore.reducer,
  billingContact: billingContactStore.reducer,
  buyFlow: buyFlowStore.reducer,
  data: dataStore.reducer,
  economicNexus: economicNexusStore.reducer,
  esb: esbStore.reducer,
  features: featuresStore.reducer,
  nextBestProduct: nextBestProductStore.reducer,
  offer: offerStore.reducer,
  order: orderStore.reducer,
  partner: partnerStore.reducer,
  productDetail: productDetailStore.reducer,
  progressBar,
  questionnaire: questionnaireStore.reducer,
  returns: returnsStore.reducer,
  riskAssessment: riskAssessmentStore.reducer,
  sharedSignup: sharedSignupStore.reducer,
  system: systemStore.reducer,
});

export default reducer;

export const defaultState: State = {
  abTesting: abTestingStore.getInitialState(),
  account: accountState,
  avataxSignup: avataxSignupStore.getInitialState(),
  billingContact: billingContactStore.getInitialState(),
  buyFlow: buyFlowStore.getInitialState(),
  data: dataStore.getInitialState(),
  economicNexus: economicNexusStore.getInitialState(),
  esb: esbStore.getInitialState(),
  features: featuresStore.getInitialState(),
  nextBestProduct: nextBestProductStore.getInitialState(),
  offer: offerStore.getInitialState(),
  order: orderStore.getInitialState(),
  partner: partnerStore.getInitialState(),
  productDetail: productDetailStore.getInitialState(),
  progressBar: progressBarState,
  questionnaire: questionnaireStore.getInitialState(),
  returns: returnsStore.getInitialState(),
  riskAssessment: riskAssessmentStore.getInitialState(),
  sharedSignup: sharedSignupStore.getInitialState(),
  system: systemStore.getInitialState(),
};
